/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import { useAuth } from '@context/authentication';

/**
 * The signed-in user id used to scope local drafts.
 *
 * Returns null (drafts disabled) whenever the id cannot be read, e.g. outside
 * the auth provider: a draft with no owner would be shared between users.
 *
 * @returns The OIDC `sub`, or null.
 */
export function useDraftUserId(): string | null {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAuth()?.user?.profile?.sub ?? null;
  } catch {
    return null;
  }
}
